
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","viewBox":"0 0 29 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 14a3 3 0 11-6 0 3 3 0 016 0z","fill":"#FF5064","stroke":"#FF5064"}}),_c('path',{attrs:{"d":"M16.793 22.777h.223l.149-.166L24.62 14.3l.3-.335-.301-.334-7.455-8.277-.149-.165H7.437v17.59h9.355zM18.12 4.633l7.255 8.072v2.54l-7.257 8.074-1.433.647h-8.54L6.25 22.07V5.895L8.145 4h8.542l1.433.632z","fill":"#FF5064","stroke":"#FF5064"}})])
          )
        }
      }
    